import type { ClientLocation } from "./ClientManagement";
import type { DistrictData } from "./Location";
import type { ClientNamePOSData } from "./Partner";

export const BookingFormContextV4 = {
  CLIENT: "client",
  RETAIL: "retail"
} as const;

export type ClientBranchSelectionV4 = Omit<
  ClientNamePOSData,
  | "clientId"
  | "clientIsDO"
  | "clientIsCOD"
  | "clientIsDfod"
  | "clientCodConfigAmount"
> & {
  clientId: string | number;
  clientCode: string;
  clientName: string;
  isFtz: boolean | undefined;
  clientIsDO: boolean | undefined;
  clientIsCOD: boolean | undefined;
  clientIsDfod: boolean | undefined;
  isShowShippingRate: boolean | undefined;
  clientCodConfigAmount: string | undefined;
  clientPhone?: string;
  clientAddress?: string;
  clientDistrict?: DistrictData;
  clientCity?: ClientLocation;
  originListZipCode?: string[];
  clientCountry?: string;
};

export class ClientMetaBookingV4 {
  formContext: typeof BookingFormContextV4[keyof typeof BookingFormContextV4] =
    BookingFormContextV4.CLIENT;
  selectedClient: ClientBranchSelectionV4 | null = null;
  selectionError: string | null = null;
  isAccountClient = false;

  constructor(fields?: Partial<ClientMetaBookingV4>) {
    Object.assign(this, fields);
  }
}
